<template>
    <div class="mainPage">
        <!-- <div style="height:82vh;overflow-y:scroll;"> -->
          <div class="topBox"><i class="el-icon-back mr10 f20" @click="goBack"></i>{{queryPage == 'banchCreate' ? '批次券':'优惠券'}}详情</div>
           <div class="mainBox">
            <div class="specialReminder" v-if="isShowTips == true"> 
                 <div class="ml20">每人每天最多可用张数需配合收银机V5.18.10及以上版本支持，如未升级，会导致优惠券无法核销。</div>
            </div>
            <div class="specialReminder" v-if="isShowTips == true"> 
                 <div class="ml20">折扣金额上限需要配合收银机V5.25.10及以上版本支持，对于未升级的版本，折扣金额上限将无法生效，版本升级后自动生效。请谨慎设置。</div>
            </div>

            <!-- 券名称 -->
            <div class="couponName">折扣券(8折券)</div>
            <!-- 查询条件 -->
            <el-row>
                <el-form label-width="100px">
                     <el-col :span="6">
                         <el-form-item label="券码：">
                              <el-input v-model="searchForm.couponCode" placeholder="请输入优惠券码"></el-input>
                         </el-form-item>
                     </el-col>
                     <el-col :span="6">
                         <el-form-item label="券使用状态：">
                               <el-select v-model="searchForm.couponUseStatus" multiple collapse-tags placeholder="全部">
                                    <el-option
                                    v-for="item in couponUseStatusList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                         </el-form-item>
                     </el-col>
                     <el-col :span="6">
                         <el-form-item label="过期时间范围：" label-width="120px">
                              <el-select v-model="searchForm.overTimeType" placeholder="全部">
                                    <el-option
                                    v-for="item in overTimeRange"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                         </el-form-item>
                     </el-col>
                     <el-col :span="6">
                         <el-form-item label="制券批次号：">
                              <el-input :disabled="queryPage == 'banchCreate' ? true:false" v-model="searchForm.couponBatchCode" placeholder="请输入制券批次号"></el-input>
                         </el-form-item>
                     </el-col>
                     <el-col :span="6">
                         <el-form-item label="手机号：">
                              <el-input v-model="searchForm.phone" placeholder="请输入制券批次号"></el-input>
                         </el-form-item>
                     </el-col>
                     <el-col :span="6">
                         <el-form-item label="会员姓名：">
                              <el-input v-model="searchForm.memberName" placeholder="请输入会员姓名"></el-input>
                         </el-form-item>
                     </el-col>
                     <el-col :span="6">
                         <el-form-item label="领券时间：">
                               <el-date-picker
                                    v-model="searchForm.collectionTime"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                         </el-form-item>
                     </el-col>

                   <el-button type="primary" class="ml10" @click="search"
                    ><i class="el-icon-search el-icon--left fw600"></i>查询</el-button
                    >
                    <el-button type="" @click="reSet"
                    ><i
                        v-if="!isLoading"
                        class="el-icon-refresh-right el-icon--left fw600"
                    ></i
                    ><i v-if="isLoading" class="el-icon-loading el-icon--left fw600"></i
                    >重置</el-button
                    >
                </el-form>
            </el-row>
            <!-- 数据统计 -->
             <el-row>
               <div class="dataBox">
                  <div class="dataItem" v-for="(item,index) in showData" :key="index">
                     <div class="dataLabel">{{item.label}}</div>
                     <div class="dataValue">{{item.value}}</div>
                  </div>
               </div>
             </el-row>
             <!-- 列表 -->
              <el-row>
                <el-col :span="24" class="flex itemsCenter">
                    <el-checkbox v-model="checkedAll" @change="selectAllChange">全部选中</el-checkbox>
                    <div class="selectCountText">已选中{{selectCount}}项</div>
                    <el-button class="ml10" type="" :disabled="selectCount == 0 ? true:false" @click="downLoad">批量导出</el-button>
                     <el-button class="ml10" type="" @click="showDownList">下载列表</el-button>
                     <el-button class="ml10" type="" @click="showDownRecord">下载记录</el-button>
                </el-col>
              </el-row>
              <el-row>
                 <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" 
                 @selection-change="handleSelectionChange"             
                 :header-cell-class-name="cellClass">
                    <el-table-column type="selection" :selectable="checkSelectable" width="55"  fixed></el-table-column>
                    <el-table-column type="index" label="序号" width="55" fixed></el-table-column>
                    <el-table-column prop="couponCode" label="券码" width="130px" fixed> </el-table-column>
                    <el-table-column prop="batchCode" label="制券批次号"  fixed> </el-table-column>
                    <el-table-column prop="discount" label="券折扣"> </el-table-column>
                    <el-table-column prop="getCouponTime" label="领券时间" width="140px" > 
                      <template slot-scope="scope">
                         {{scope.row.getCouponTime ? scope.row.getCouponTime:'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="activeType" label="活动方式"> </el-table-column>
                    <el-table-column prop="memberName" label="会员姓名"> 
                       <template slot-scope="scope">
                         {{scope.row.memberName ? scope.row.memberName:'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="memberPhone" label="会员手机号" width="100px" > 
                       <template slot-scope="scope">
                         {{scope.row.memberPhone ? scope.row.memberPhone:'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="currentConsumptionAmount" label="本次消费金额" width="140px" > 
                        <template slot-scope="scope">
                         {{scope.row.currentConsumptionAmount ? scope.row.currentConsumptionAmount:'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="writeOffTime" label="核销时间" width="140px"> 
                       <template slot-scope="scope">
                         {{scope.row.writeOffTime ? scope.row.writeOffTime:'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="associationOrderNumber" label="关联销售单号" width="140px"> 
                      <template slot-scope="scope">
                         {{scope.row.associationOrderNumber ? scope.row.associationOrderNumber:'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="writeOffShop" label="核销门店" width="140px"> 
                       <template slot-scope="scope">
                         {{scope.row.writeOffShop ? scope.row.writeOffShop:'-'}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="canUseDate" label="使用生效期" width="140px"> </el-table-column>
                    <el-table-column prop="canNotUseDate" label="使用失效期" width="140px"> </el-table-column>
                    <el-table-column prop="useStatus" label="券使用状态" width="140px"> 
                       <template slot-scope="scope">
                         {{scope.row.useStatus == '1' ? '已制券，待激活':scope.row.useStatus == '2' ? '未使用':scope.row.useStatus == '3' ? '已使用':scope.row.useStatus == '4' ? '已过期':'-'}}
                      </template>
                    </el-table-column>
                  </el-table>
                      <div class="footerBox">
                        <!-- 分页区域 -->
                        <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="queryInfo.currPage"
                          :page-sizes="[10, 20, 30, 50]"
                          :page-size="queryInfo.pageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total"
                        ></el-pagination>
                      </div>
              </el-row>
           </div>
            <DownLoadList  :dialogListVisible="isShowList" @handleClose='detailDialogClose'></DownLoadList>
            <DownLoadRecord  :dialogRecordVisible="isShowRecord" @handleRecordClose='recordDialogClose'></DownLoadRecord>

            <el-dialog
              title=""
              :visible.sync="downLoadDialogVisible"
              width="30%"
              :show-close='false'
              :close-on-click-modal="false"
              class="downLoadDialog"
              >
              <div class="flex itemsCenter">
                  <i class="el-icon-warning warningIcon"></i>
                  <span class="tipsText">提示</span>
              </div>
              <div class="tipsContent">
                已提交导出，请勿重复操作。请到下载列表中查看导出进度。进度完成后，点击"下载"查看数据。点击确定后，关闭弹窗。
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="downLoadDialogVisible = false">稍后再说</el-button>
                <el-button type="primary" @click="showDownList">立即前往</el-button>
              </span>
            </el-dialog>
    </div>
</template>

<script>
import DownLoadList from "./components/DownLoadList.vue"
import DownLoadRecord from "./components/DownLoadRecord.vue"
export default {
   components:{
    DownLoadList,
    DownLoadRecord
  },
    data(){
        return {
          queryInfo:{
            pageSize: 10,
            currPage: 1,
            condition:{},
          },
          downLoadDialogVisible:false,
          isShowRecord:false,
          isShowList:false,
           total:2,
           checkedAll:false,
           isShowTips:true,
           isLoading:false,
           searchForm:{
              couponCode:'',
              couponUseStatus:[],
              overTimeType:'1',
              couponBatchCode:'',
              phone:'',
              memberName:'',
              collectionTime:[],
           },
           couponUseStatusList:[
              {
                 label:'未使用',
                 value:'1',
              },
               {
                 label:'已使用',
                 value:'2',
              },
               {
                 label:'已过期',
                 value:'3',
              },
               {
                 label:'已制券，待激活',
                 value:'4',
              },
           ],
           overTimeRange:[
            {
              label:'已过期1个月内',
              value:'1',
            },
            {
              label:'已过期3个月内',
              value:'2',
            },
            {
              label:'已过期6个月内',
              value:'3',
            },
            {
              label:'已过期1年内',
              value:'4',
            },
            {
              label:'全部',
              value:'5',
            },
           ],
           showData:[
            {
               label:'已制券，待激活',
               value:'10',
            },
             {
               label:'未使用',
               value:'0',
            },
             {
               label:'已使用',
               value:'0',
            },
             {
               label:'已过期',
               value:'0',
            },
             {
               label:'累计交易额（元）',
               value:'0.00',
            },
           ],
           tableData:[
            {
              couponCode:'436841463434',
              batchCode:'12809646',
              discount:'80%',
              getCouponTime:'',
              activeType:'批量制券',
              memberName:'',
              memberPhone:'',
              currentConsumptionAmount:'',
              writeOffTime:'',
              associationOrderNumber:'',
              writeOffShop:'',
              canUseDate:'激活后，当天生效',
              canNotUseDate:'30天',
              useStatus:'1'
            },
            {
              couponCode:'95072121066',
              batchCode:'12809646',
              discount:'80%',
              getCouponTime:'',
              activeType:'批量制券',
              memberName:'',
              memberPhone:'',
              currentConsumptionAmount:'',
              writeOffTime:'',
              associationOrderNumber:'',
              writeOffShop:'',
              canUseDate:'激活后，当天生效',
              canNotUseDate:'30天',
              useStatus:'1'
            },
           ],
           multipleSelection:[],
           DisableSelection:false, //全选按钮隐藏
           selectCount:0,
           queryPage:'',
        }
    },
    created(){
       this.searchForm.couponBatchCode = this.$route.query.batchNumber
       this.queryPage = this.$route.query.page
    },
    methods:{
      //点击导出按钮
      downLoad(){
        this.downLoadDialogVisible = true
      },
      //打开列表弹框
      showDownList(){
        this.downLoadDialogVisible = false
         this.isShowList = true
      },
        //打开记录弹框
        showDownRecord(){
          this.isShowRecord = true
        },
        //查看详情关闭
        detailDialogClose(e){
          this.isShowList = e
        },
        //下载记录关闭
        recordDialogClose(e){
           this.isShowRecord = e
        },
        //返回
        goBack (){
          if (this.queryPage == 'banchCreate') {
            this.$router.push({path:'/banchCreatedCoupon'})
          }else{
            this.$router.push({path:'/couponManage'})
          }
            
        },
       reSet(){
        this.searchForm = {
            couponCode:'',
            couponUseStatus:[],
            overTimeType:'1',
            couponBatchCode:'',
            phone:'',
            memberName:'',
            collectionTime:[],
        }
      this.queryInfo.currPage = 1  
      //   this.getListData();
    },
    search(){

    },
    //表格选择
     handleSelectionChange(val) {
        this.multipleSelection = val
        this.selectCount = this.multipleSelection.length
      },
      //表格多选框禁用
      checkSelectable(){
          if ( this.checkedAll == false) {
            this.DisableSelection = false 
            // this.selectCount = 0
            return true;  //不禁用
        } else {
          this.DisableSelection = true 
           this.selectCount = this.total
           this.$refs.multipleTable.clearSelection()
          return false; 
        }
      },
      //表格全选按钮隐藏
       //全选按钮隐藏
    cellClass(row){
          if(this.DisableSelection){
            if (row.columnIndex === 0) {
              return 'DisableSelection'
            }
          }   
    },
    //全选change
    selectAllChange(){
        if (this.checkedAll == false) {
           this.selectCount = 0
        }
    },
       // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
    //   this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
    //   this.getListData();
    },
    }
}
</script>

<style lang="less" scoped>
.mainPage {
  width: 99%;
  height: 90vh;
  /* padding: 30px; */
  background: #fff;
  overflow-y: scroll;
}
.topBox{
    /* width: 100%; */
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #ddd;
}
.f20{
    font-size: 20px;
    cursor: pointer;
}
.specialReminder{
    padding: 0 30px;
    background: #fff0f0;
    border: 1px solid #ff8080;
    border-radius: 7px;
    height: 50px;
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    font-size: 15px;
    color: #606266;
}
.mainBox{
    /* width: 100%; */
    // height: 70vh;
    background:#fff;
    padding: 30px;
    // overflow-y: scroll;
}
.couponName{
    margin-bottom: 22px;
    font-size: 18px;
    color: #333;
}
/deep/ .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner{
    width: 100%;
}
/deep/ .el-button--primary {
  background-color: rgb(245, 154, 35);
  border-color: rgb(245, 154, 35);
}
/deep/ .el-button:focus,
.el-button:hover {
  color: rgb(245, 154, 35);
  border-color: #f5dab1;
  background-color: #fdf6ec;
}
/deep/ .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
      color: #C0C4CC;
    cursor: not-allowed;
    background-image: none;
    background-color: #FFF;
    border-color: #EBEEF5;
}
.dataBox{
     display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    height: 90px;
    border: 1px solid #e5e5e5;
    color: #303133;
    border-radius: 4px;
    margin: 15px 0 24px;
}
.dataItem{
    flex: 1 1;
    text-align: center;
    border-right: 1px solid #e5e5e5;
    line-height: 1.75;
    padding: 0 8px;
}
.dataItem:last-child{
  border-right: none;
}
.dataLabel{
 font-size: 15px;
}
.dataValue{
  font-weight: 700;
  font-size: 15px;
}
 /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    border-color: rgb(245,154,35);
    background: rgb(245,154,35);
 }
 /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #222;
}
 /deep/ .el-checkbox__input.is-focus .el-checkbox__inner{
  border-color: rgb(245,154,35) !important;
 } 
  /deep/ .el-checkbox__input .el-checkbox__inner:hover{
    border-color: rgb(245,154,35) !important;
  }
  .selectCountText{
      color: rgb(153, 153, 153);
      font-size: 14px;
  }
  .itemsCenter{
    align-items: center;
  } 
  /deep/ .el-table th>.cell{
    padding: 10px;
  }
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: #f59a23 !important;
    border-color: #f59a23 !important;
}
//表格全选按钮隐藏样式
/deep/ .el-table .DisableSelection .cell .el-checkbox__inner{
          display: none;
          position: relative;
        }
/deep/  .el-table .DisableSelection .cell:before{
          content: "";
          position: absolute;
  }
  .downLoadDialog /deep/ .el-dialog__body{
    padding:0 30px 30px 30px;
  }
  .downLoadDialog /deep/ .el-dialog{
    border-radius: 5px;
    margin-top: 20vh !important;
  }
  .warningIcon{
    color: #f59a23;
    font-size: 25px;
  }
  .tipsText{
    font-size: 16px;
    color: #222;
    margin-left: 20px;
  }
  .itemsCenter{
    align-items: center;
  }
  .tipsContent{
    font-size: 14px;
    color: #666;
    margin-top: 8px;
    margin-left: 43px;
    line-height: 23px;
  }
</style>